module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.canPerformUserActions && _vm.accountUserDecorated.isNotArchived && _vm.accountUserDecorated.isActivated) ? _c('ul', {
    staticClass: "nav nav-actions"
  }, [(_vm.accountUserDecorated.isEnabled) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleDisable
    }
  }, [(_vm.performingUserDisabling) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-times fa-fw"
  }), _vm._v("\n        Disable User\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.accountUserDecorated.isDisabled) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleEnable
    }
  }, [(_vm.performingUserEnabling) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-refresh fa-fw"
  }), _vm._v("\n        Enable User\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.accountUserDecorated.isNotArchived) ? _c('li', [_c('a', {
    on: {
      "click": _vm.handleArchive
    }
  }, [(_vm.performingUserArchive) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  }) : _c('i', {
    staticClass: "fa fa-archive fa-fw"
  }), _vm._v("\n        Archive User\n      ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('user-details', {
    attrs: {
      "can-change-role": false
    }
  }, [_c('div', {
    slot: "cropper"
  }, [(_vm.loggedInUserIsAdmin) ? _c('photo-cropper', {
    attrs: {
      "name": "driver",
      "photo-storage-path": _vm.accountUser.driver_profile.photo_storage_path,
      "original-name": _vm.accountUser.driver_profile.photo_name,
      "original-data-uri": _vm.originalPhotoDataUri,
      "class-name": "profile-photo",
      "label-text": "Profile Photo"
    },
    model: {
      value: (_vm.photo),
      callback: function($$v) {
        _vm.photo = $$v
      },
      expression: "photo"
    }
  }) : (_vm.accountUser.driver_profile && _vm.accountUser.driver_profile.photo_storage_path) ? _c('div', {
    staticClass: "preview"
  }, [_c('img', {
    staticClass: "profile-photo",
    attrs: {
      "src": ((_vm.accountUser.driver_profile.photo_storage_path) + "/256x256.jpg")
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), _c('ladda-button', {
    staticClass: "btn btn-success",
    attrs: {
      "on-click": _vm.saveDriver
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Save")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-20b967be"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/DriverForm.vue
// module id = 949
// module chunks = 0